import { useQuery } from "@tanstack/solid-query"
import { createFileRoute } from "@tanstack/solid-router"
import { Show } from "solid-js"
import { orpc } from "~/lib/orpc"

export const Route = createFileRoute("/_authenticated/test")({
  beforeLoad: ({ context }) =>
    context.queryClient.prefetchQuery(
      orpc.tablet.citizens.list.queryOptions({
        input: {
          search: "",
          pagination: {
            pageSize: 10,
            pageIndex: 0
          }
        }
      })
    ),
  component: RouteComponent
})

function RouteComponent() {
  const query = useQuery(() =>
    orpc.tablet.citizens.list.queryOptions({
      input: {
        search: "",
        pagination: {
          pageSize: 10,
          pageIndex: 0
        }
      }
    })
  )

  return (
    <Show when={query.isSuccess}>
      <pre>{JSON.stringify(query.data, null, 2)}</pre>
    </Show>
  )
}
